import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../Firebase";
import firebase from "firebase";
import axios from "axios";
import { country } from "../Allapis";
import { Apiurl } from "../api_urls";
import { useDispatch } from "react-redux";
import { loginuser } from "../redux_store/LoginSlice";
import { GToaster } from "./g_toaster";
import { CircularProgress } from "@material-ui/core";
import { Box, Modal } from "@mui/material";
import LoginTabs from "./LoginTabs";
import ForgotPasswordModal from "./ForgotPassword";
import Termagree from "./Termagree";
import { OpenInNew } from "@material-ui/icons";
import { setAuthToken } from "../api/axiosConfig";

const toster = new GToaster();

function Login() {
    const objdata = {
        email: "",
        country_code: "",
        contact_number: "",
        password: "",
        role: "passenger",
    };

    const navi = useNavigate();
    const dispatch = useDispatch();

    const [obj, setobj] = useState({ ...objdata });
    const [otpdata, setotpdata] = useState(null);
    const [code] = useState(country);
    const [userdata, setuserdata] = useState(null);
    const [btnloader, setbtnloader] = useState(false);
    const [tab, setTab] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [isagree, setisagree] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    /*
     * IMPORTANT:
     * Keep one RecaptchaVerifier instance for the whole component.
     */
    useEffect(() => {
        return () => {
            if (window.recaptchaVerifier) {
                try {
                    window.recaptchaVerifier.clear();
                } catch (e) {
                    console.log("reCAPTCHA cleanup error:", e);
                }

                window.recaptchaVerifier = null;
            }
        };
    }, []);

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    function handlechange(key, value) {
        setobj((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    /*
     * Create/reuse Firebase reCAPTCHA verifier.
     */
    const getRecaptchaVerifier = () => {
        if (window.recaptchaVerifier) {
            return window.recaptchaVerifier;
        }

        if (!document.getElementById("recaptcha-container")) {
            throw new Error("reCAPTCHA container not found");
        }

        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            "recaptcha-container",
            {
                size: "invisible",

                callback: () => {
                    console.log("reCAPTCHA solved");
                },

                "expired-callback": () => {
                    console.log("reCAPTCHA expired");

                    if (window.recaptchaVerifier) {
                        try {
                            window.recaptchaVerifier.clear();
                        } catch (e) {
                            console.log(e);
                        }

                        window.recaptchaVerifier = null;
                    }
                },
            }
        );

        return window.recaptchaVerifier;
    };

    async function logdata(e) {
        e.preventDefault();

        if (!isagree) {
            toster.warning({
                title: "Please accept Privacy Policy and Terms of Use",
            });
            return;
        }

        const newobj = !tab
            ? {
                  email: obj.email,
                  password: obj.password,
                  role: "passenger",
              }
            : {
                  country_code: obj.country_code,
                  mobile: obj.contact_number,
                  role: "passenger",
              };

        localStorage.removeItem("persist:root");

        setbtnloader(true);

        try {
            const response = await axios.post(
                !tab
                    ? Apiurl.USER_EMAIL_LOGIN_URL
                    : Apiurl.USER_LOGIN_URL,
                newobj
            );

            if (response.data.status === 300) {
                toster.warning({
                    title:
                        "This contact no. is not registered. Please check your contact number.",
                });

                setbtnloader(false);
                return;
            }

            if (response.data.status === 301) {
                toster.warning({
                    title: "Please Check Your Password",
                });

                setbtnloader(false);
                return;
            }

            if (response.status !== 200) {
                toster.warning({
                    title:
                        "Your account status is inactive. Please contact the admin.",
                });

                setbtnloader(false);
                return;
            }

            setuserdata(response.data.data);

            /*
             * Save API token.
             */
            if (response.data.access_token) {
                localStorage.setItem(
                    "access_token",
                    response.data.access_token
                );
            }

            if (response.data.data?.role) {
                localStorage.setItem(
                    "role",
                    response.data.data.role
                );
            }

            /*
             * EMAIL LOGIN
             */
            if (!tab) {
                userLogged(response.data.data);
                return;
            }

            /*
             * PHONE LOGIN
             */
            const countryCode = obj.country_code?.trim();
            const contactNumber = obj.contact_number?.trim();

            if (!countryCode || !contactNumber) {
                toster.warning({
                    title: "Please enter your country code and mobile number.",
                });

                setbtnloader(false);
                return;
            }

            const phoneNumber = `${countryCode}${contactNumber}`;

            console.log("Sending Firebase OTP to:", phoneNumber);

            const appVerifier = getRecaptchaVerifier();

            /*
             * Firebase sends OTP.
             */
            const confirmationResult =
                await auth.signInWithPhoneNumber(
                    phoneNumber,
                    appVerifier
                );

            console.log(
                "Firebase confirmation result:",
                confirmationResult
            );

            setotpdata(confirmationResult);
            setbtnloader(false);

            toster.success({
                title:
                    "OTP has been sent to your registered mobile number.",
            });
        } catch (err) {
            console.error("PHONE LOGIN ERROR:", err);

            setbtnloader(false);

            /*
             * Firebase errors are much more useful than err.message alone.
             */
            const firebaseError =
                err?.code
                    ? `${err.code}: ${err.message}`
                    : err?.message || "Unable to send OTP";

            toster.error({
                title: firebaseError,
            });

            /*
             * If reCAPTCHA becomes invalid, destroy it.
             * A new one will be created on the next attempt.
             */
            if (
                err?.code === "auth/invalid-app-credential" ||
                err?.code === "auth/captcha-check-failed" ||
                err?.code === "auth/network-request-failed"
            ) {
                if (window.recaptchaVerifier) {
                    try {
                        window.recaptchaVerifier.clear();
                    } catch (e) {
                        console.log(e);
                    }

                    window.recaptchaVerifier = null;
                }
            }
        }
    }

    /*
     * OTP verification.
     */
    async function verify(e) {
        e.preventDefault();

        if (!otpdata) {
            toster.error({
                title: "OTP session has expired. Please request a new OTP.",
            });
            return;
        }

        const formData = new FormData(e.currentTarget);
        const otp = formData.get("Verify");

        if (!otp || otp.length !== 6) {
            toster.warning({
                title: "Please enter the 6-digit OTP.",
            });
            return;
        }

        setbtnloader(true);

        try {
            const result = await otpdata.confirm(otp);

            console.log("Firebase OTP verified:", result);

            userLogged(userdata);
        } catch (err) {
            console.error("OTP VERIFY ERROR:", err);

            setbtnloader(false);

            toster.error({
                title:
                    err?.message ||
                    "Invalid OTP. Please try again.",
            });
        }
    }

    /*
     * Resend OTP.
     *
     * Do NOT create another RecaptchaVerifier here.
     */
    async function resend() {
        try {
            setbtnloader(true);

            const countryCode = obj.country_code?.trim();
            const contactNumber = obj.contact_number?.trim();

            if (!countryCode || !contactNumber) {
                toster.warning({
                    title: "Invalid phone number.",
                });

                setbtnloader(false);
                return;
            }

            const phoneNumber = `${countryCode}${contactNumber}`;

            console.log("Resending Firebase OTP to:", phoneNumber);

            /*
             * Clear the previous verifier before creating
             * another one if necessary.
             */
            if (window.recaptchaVerifier) {
                try {
                    window.recaptchaVerifier.clear();
                } catch (e) {
                    console.log(e);
                }

                window.recaptchaVerifier = null;
            }

            const appVerifier = getRecaptchaVerifier();

            const confirmationResult =
                await auth.signInWithPhoneNumber(
                    phoneNumber,
                    appVerifier
                );

            setotpdata(confirmationResult);

            setbtnloader(false);

            toster.success({
                title: "OTP has been resent.",
            });
        } catch (error) {
            console.error("RESEND OTP ERROR:", error);

            setbtnloader(false);

            toster.error({
                title:
                    error?.message ||
                    "Unable to resend OTP.",
            });

            if (window.recaptchaVerifier) {
                try {
                    window.recaptchaVerifier.clear();
                } catch (e) {
                    console.log(e);
                }

                window.recaptchaVerifier = null;
            }
        }
    }

    const userLogged = (userdata) => {
        toster.success({
            title: "LoggedIn Successfully",
        });

        setobj({ ...objdata });

        /*
         * IMPORTANT:
         *
         * Your API response appears to store access_token
         * outside response.data.data.
         *
         * If your API token is inside userdata instead,
         * keep your original logic.
         */
        if (userdata?.access_token) {
            setAuthToken(userdata.access_token);
        }

        dispatch(loginuser(userdata));

        setbtnloader(false);
        setotpdata(null);

        navi("/mybookings");

        localStorage.removeItem("user");
        localStorage.removeItem("username");
        localStorage.removeItem("usercontact");
    };

    const onClose = () => {
        setModalOpen(false);
    };

    function changeagreestate(e) {
        setisagree(e);
        setOpenModal(false);
    }

    function closeVal() {
        setOpenModal(false);
    }

    return (
        <>
            {/* 
              IMPORTANT:
              Keep this container mounted all the time.
              Do NOT put another element with this same ID
              inside the OTP/login conditional.
            */}
            <div
                id="recaptcha-container"
                
            />

            <div className="row">
                <div className="col-xl-8 col-12">
                    <Box
                        className="page-title-area item-bg-1 jarallax"
                        sx={{
                            height: {
                                xl: "100vh",
                                sm: "48vh",
                                xs: "45vh",
                            },
                            width: "100%",
                            boxSizing: "border-box",
                        }}
                    />
                </div>

                <div className="col-xl-4 col-12">
                    {otpdata ? (
                        <section className="sign-up-area">
                            <div className="container">
                                <div className="contact-form-action">
                                    <div className="form-heading text-center">
                                        <h3 className="form-title">
                                            Verify Your OTP
                                        </h3>

                                        <p className="reset-desc">
                                            Enter the six-digit OTP
                                            received on your contact
                                            number.
                                        </p>
                                    </div>

                                    <form onSubmit={verify}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        name="Verify"
                                                        placeholder="Enter Your OTP"
                                                        inputMode="numeric"
                                                        maxLength={6}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary mt-4"
                                                            onClick={resend}
                                                            disabled={
                                                                btnloader
                                                            }
                                                        >
                                                            Resend OTP
                                                        </button>
                                                    </div>

                                                    <div className="col-6 d-flex justify-content-end">
                                                        {btnloader ? (
                                                            <CircularProgress />
                                                        ) : (
                                                            <button
                                                                className="default-btn btn-two mt-4 m-0"
                                                                type="submit"
                                                            >
                                                                Verify OTP
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    ) : (
                        <>
                            <ForgotPasswordModal
                                open={modalOpen}
                                onClose={onClose}
                                usertype="passenger"
                            />

                            <Modal
                                open={openModal}
                                onClose={() =>
                                    setOpenModal(!openModal)
                                }
                            >
                                <Box>
                                    <Termagree
                                        isagree={isagree}
                                        usertype="passenger"
                                        handlechange={
                                            changeagreestate
                                        }
                                        closeVal={closeVal}
                                    />
                                </Box>
                            </Modal>

                            <section className="sign-up-area">
                                <div className="container">
                                    <div className="contact-form-action">
                                        <div className="form-heading text-center mb-3">
                                            <h3 className="form-title">
                                                Login to your account!
                                            </h3>

                                            <p className="form-desc">
                                                with your social network.
                                            </p>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent:
                                                    "flex-end",
                                            }}
                                        >
                                            <a
                                                style={{
                                                    cursor: "pointer",
                                                    background:
                                                        "#e41e22",
                                                    padding:
                                                        "5px 20px",
                                                    color: "white",
                                                    borderRadius:
                                                        "5px",
                                                    textDecoration:
                                                        "none",
                                                }}
                                                onClick={() =>
                                                    navi("/")
                                                }
                                            >
                                                Back
                                            </a>
                                        </div>

                                        <LoginTabs
                                            tab={tab}
                                            handleTabChange={
                                                handleTabChange
                                            }
                                        />

                                        <form onSubmit={logdata}>
                                            <div className="row">
                                                {!tab ? (
                                                    <>
                                                        <div className="col-12 mb-2">
                                                            <label className="form-label">
                                                                Registered
                                                                Email
                                                            </label>

                                                            <input
                                                                required
                                                                className="form-control mb-3"
                                                                type="email"
                                                                name="email"
                                                                value={
                                                                    obj.email
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) =>
                                                                    handlechange(
                                                                        e
                                                                            .target
                                                                            .name,
                                                                        e
                                                                            .target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-12 mb-2">
                                                            <label className="form-label">
                                                                Password
                                                            </label>

                                                            <input
                                                                required
                                                                className="form-control mb-3"
                                                                type="password"
                                                                name="password"
                                                                value={
                                                                    obj.password
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) =>
                                                                    handlechange(
                                                                        e
                                                                            .target
                                                                            .name,
                                                                        e
                                                                            .target
                                                                            .value
                                                                    )
                                                                }
                                                                minLength={6}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="col-lg-3 col-sm-4 col-4 mb-2">
                                                            <label className="form-label">
                                                                Country
                                                            </label>

                                                            <select
                                                                className="form-select form-control form-select-lg"
                                                                value={
                                                                    obj.country_code
                                                                }
                                                                name="country_code"
                                                                onChange={(
                                                                    e
                                                                ) =>
                                                                    handlechange(
                                                                        e
                                                                            .target
                                                                            .name,
                                                                        e
                                                                            .target
                                                                            .value
                                                                    )
                                                                }
                                                                required
                                                            >
                                                                <option value="">
                                                                    Select
                                                                </option>

                                                                {code.map(
                                                                    (
                                                                        row
                                                                    ) => (
                                                                        <option
                                                                            key={
                                                                                row.name
                                                                            }
                                                                            value={
                                                                                row.dial_code
                                                                            }
                                                                        >
                                                                            {
                                                                                row.dial_code
                                                                            }{" "}
                                                                            {
                                                                                row.name
                                                                            }
                                                                        </option>
                                                                    )
                                                                )}
                                                            </select>
                                                        </div>

                                                        <div className="col-lg-9 col-sm-8 col-8 mb-1">
                                                            <label className="form-label">
                                                                Phone No.
                                                            </label>

                                                            <input
                                                                required
                                                                className="form-control mb-3"
                                                                type="tel"
                                                                name="contact_number"
                                                                value={
                                                                    obj.contact_number
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) =>
                                                                    handlechange(
                                                                        e
                                                                            .target
                                                                            .name,
                                                                        e
                                                                            .target
                                                                            .value.replace(
                                                                                /\D/g,
                                                                                ""
                                                                            )
                                                                    )
                                                                }
                                                                maxLength={10}
                                                            />
                                                        </div>
                                                    </>
                                                )}

                                                <div className="col-12 mt-2 mb-3 d-flex align-items-center">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="termsCheck"
                                                        checked={
                                                            isagree
                                                        }
                                                        readOnly
                                                    />

                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="termsCheck"
                                                        style={{
                                                            color: "#60686c",
                                                            fontSize: 15,
                                                            marginTop:
                                                                "6px",
                                                            marginLeft:
                                                                "10px",
                                                        }}
                                                    >
                                                        I have read and
                                                        understand the{" "}
                                                        <span
                                                            style={{
                                                                cursor: "pointer",
                                                                color: "#117fb7",
                                                                textDecoration:
                                                                    "underline",
                                                            }}
                                                            onClick={() =>
                                                                setOpenModal(
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            Privacy Policy
                                                            and Terms of Use{" "}
                                                            <OpenInNew
                                                                sx={{
                                                                    fontSize:
                                                                        "10px",
                                                                }}
                                                            />
                                                        </span>
                                                    </label>
                                                </div>

                                                <div className="col-12">
                                                    {btnloader ? (
                                                        <CircularProgress />
                                                    ) : (
                                                        <button
                                                            className="default-btn btn-two"
                                                            type="submit"
                                                            disabled={
                                                                !isagree
                                                            }
                                                        >
                                                            Log In Now
                                                        </button>
                                                    )}
                                                </div>

                                                <div
                                                    className="col-12"
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                    }}
                                                >
                                                    <p className="account-desc">
                                                        Not a member?{" "}
                                                        <a
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                                navi(
                                                                    "/signup"
                                                                )
                                                            }
                                                        >
                                                            Register
                                                        </a>
                                                    </p>

                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#117fb7",
                                                        }}
                                                        onClick={() =>
                                                            setModalOpen(
                                                                true
                                                            )
                                                        }
                                                    >
                                                        Forgot Password?
                                                    </span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default Login;
